import { render, staticRenderFns } from "./PersonnelTable.vue?vue&type=template&id=df96c2a8&scoped=true"
import script from "./PersonnelTable.vue?vue&type=script&lang=js"
export * from "./PersonnelTable.vue?vue&type=script&lang=js"
import style0 from "./PersonnelTable.vue?vue&type=style&index=0&id=df96c2a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df96c2a8",
  null
  
)

export default component.exports